import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39e93f3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex gap-2 justify-content-start align-items-start mb-3" }
const _hoisted_2 = { class: "comment d-flex flex-column gap-1 w-100" }
const _hoisted_3 = { class: "comment__name m-0 d-flex gap-1 justify-content-start align-items-end" }
const _hoisted_4 = {
  class: "comment__date",
  href: "#"
}
const _hoisted_5 = { class: "comment__text py-2 px-3 border border-1 rounded-2" }
const _hoisted_6 = { class: "comment__actions d-flex gap-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_avatar = _resolveComponent("avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_avatar, {
      class: "fw-bold",
      name: _ctx.commenter.name
    }, null, 8, ["name"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, [
        _createTextVNode(_toDisplayString(_ctx.commenter.name) + " ", 1),
        _createElementVNode("span", _hoisted_4, _toDisplayString(new Date(_ctx.comment.createdAt).toDateString()), 1)
      ]),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.comment.comment), 1),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("a", {
          href: "#",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleEditComment && _ctx.handleEditComment(...args)), ["stop"])),
          disabled: ""
        }, "Edit"),
        _createElementVNode("a", {
          href: "#",
          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDeleteComment && _ctx.handleDeleteComment(...args)), ["stop"])),
          disabled: ""
        }, "Delete")
      ])
    ])
  ]))
}